import { ClinicianListSearch } from "./clinician-list-search";
import { ClinicianListFilter } from "./clinician-list-filter";
import { ClinicianList } from "./clinician-list";

export const FindClinicians = () => {
    return (
        <>
            <div className="flex flex-1 p-4 md:py-5">
                <ClinicianListSearch />
            </div>
            <div className="h-full flex-auto p-4 md:py-5">
                <div className="container mx-auto flex flex-col gap-x-8 gap-y-4 md:flex-row">
                    <div className="flex h-fit lg:sticky lg:top-26">
                        <ClinicianListFilter />
                    </div>
                    <div className="flex flex-1">
                        <ClinicianList />
                    </div>
                </div>
            </div>
        </>
    );
};
